// extracted by mini-css-extract-plugin
export default {"text":"index-module_text_c8Z9l","index":"index-module_index_TeoR2","content":"index-module_content_mT-B6","title":"index-module_title_AcPEF","subTitle":"index-module_subTitle_JSS--"};